import {
  Bot,
  BrainCircuit,
  Cpu,
  Workflow,
  Network,
  Sparkles,
  Wand2,
  Antenna,
  Database,
  Terminal,
  ScanLine,
  MessageSquare,
  Activity,
  Layers,
  Gauge,
  Zap,
} from "lucide-react";
import { NODE_LAYOUT, NODE_META, TEAM_BOUNDS } from "@/lib/agentNetwork";

// One distinctive futuristic icon per agent (4 per team × 4 teams)
const NODE_ICONS = [
  // Team A — Input / Intake
  Bot, BrainCircuit, MessageSquare, Sparkles,
  // Team B — Process / Orchestration
  Workflow, Network, Cpu, Antenna,
  // Team D — Storage / Execution
  Database, ScanLine, Terminal, Wand2,
  // Team C — Output / Delivery
  Activity, Layers, Gauge, Zap,
];

const HEX_POINTS = "28,3 50,16 50,40 28,53 6,40 6,16";

const AgentNodes = () => {
  return (
    <div className="km-nodes" aria-hidden="true">
      {/* Team labels — one per team frame */}
      {TEAM_BOUNDS.map((b) => (
        <div
          key={`label-${b.label}`}
          className="km-team-label"
          style={{ left: `${b.cx * 100}%`, top: `${b.cy * 100}%` }}
        >
          <span className="km-team-label__tick" />
          <span>TEAM&nbsp;{b.label}</span>
          <span className="km-team-label__tick" />
        </div>
      ))}

      {/* Individual hexagonal agent stations */}
      {NODE_LAYOUT.map(([nx, ny], i) => {
        const meta = NODE_META[i];
        const isLead = !!meta.isLead;
        const Icon = NODE_ICONS[i] || Bot;

        return (
          <div
            key={i}
            className={"km-node" + (isLead ? " km-node--lead" : "")}
            data-team={meta.teamLabel}
            style={{ left: `${nx * 100}%`, top: `${ny * 100}%` }}
          >
            <svg
              className="km-node__shape"
              viewBox="0 0 56 56"
              width="46"
              height="46"
              aria-hidden="true"
            >
              <defs>
                <linearGradient id={`km-hex-${i}`} x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="rgba(0,229,255,0.18)" />
                  <stop offset="55%" stopColor="rgba(17,35,50,0.85)" />
                  <stop offset="100%" stopColor="rgba(17,35,50,0.95)" />
                </linearGradient>
              </defs>
              <polygon
                points={HEX_POINTS}
                fill="none"
                stroke="rgba(190,200,220,0.22)"
                strokeWidth="3"
                transform="translate(28 28) scale(1.14) translate(-28 -28)"
              />
              <polygon
                points={HEX_POINTS}
                fill={`url(#km-hex-${i})`}
                stroke="rgba(208,218,232,0.85)"
                strokeWidth="1.05"
                strokeLinejoin="miter"
              />
              <polygon
                points={HEX_POINTS}
                fill="none"
                stroke="rgba(0,229,255,0.45)"
                strokeWidth="0.7"
                transform="translate(28 28) scale(0.78) translate(-28 -28)"
              />
              <line x1="28" y1="3" x2="28" y2="7" stroke="rgba(0,229,255,0.9)" strokeWidth="1.1" />
              <line x1="28" y1="49" x2="28" y2="53" stroke="rgba(0,229,255,0.9)" strokeWidth="1.1" />
            </svg>
            <Icon
              className="km-node__icon"
              size={17}
              strokeWidth={1.6}
              aria-hidden="true"
            />
          </div>
        );
      })}
    </div>
  );
};

export default AgentNodes;
